import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config'; // Import the appConfig

bootstrapApplication(App, appConfig) // Pass the appConfig object here
  .catch((err) => console.error(err));
